import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import ProcessFlows from '../pages/processFlow/ProcessFlows';
import ProcessFlowEditor from '../components/processFlow/ProcessFlowEditor';

const processFlowRoutes = [
  // Process Flows list page
  <Route
    key="process-flows-list"
    path="process-flows"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'process_flows', action: 'read' }}>
        <ProcessFlows />
      </ProtectedRoute>
    }
  />,

  // Process Flow create page
  <Route
    key="process-flow-create"
    path="process-flows/create"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'process_flows', action: 'create' }}>
        <ProcessFlowEditor />
      </ProtectedRoute>
    }
  />,

  // Process Flow view page (read-only)
  <Route
    key="process-flow-view"
    path="process-flows/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'process_flows', action: 'read' }}>
        <ProcessFlowEditor readOnly />
      </ProtectedRoute>
    }
  />,

  // Process Flow edit page
  <Route
    key="process-flow-edit"
    path="process-flows/:id/edit"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'process_flows', action: 'update' }}>
        <ProcessFlowEditor />
      </ProtectedRoute>
    }
  />,
];

export default processFlowRoutes;